import { render, staticRenderFns } from "./Workshops__id.vue?vue&type=template&id=92b9f75c&scoped=true&"
import script from "./Workshops__id.vue?vue&type=script&lang=js&"
export * from "./Workshops__id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b9f75c",
  null
  
)

export default component.exports